export default __webpack_public_path__ + "images/dfad2f921506afbea0afb7f0782e5604.png";